import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Chip from "@material-ui/core/Chip";

const AdmissionsBadge = ({ requests, admissions }) => {
  const requestCount = requests == null ? "-" : requests;
  const admissionCount = admissions == null ? "-" : admissions;
  const status = `${requestCount} / ${admissionCount}`;
  return (
    <Tooltip title="Encaminhamentos/Admissões">
      <Chip className="admissions-badge-avatar" label={status}></Chip>
    </Tooltip>
  );
};

export default AdmissionsBadge;
